import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <img src="/logo-kasa-white.png" alt="Logo Kasa" />
      <h2>© 2020 Kasa. All rights reserved</h2>
    </div>
  );
};

export default Footer;
